import { of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { JhiEventManager } from 'ng-jhipster';
import {
    HttpInterceptor,
    HttpRequest,
    HttpHandler,
    HttpResponse,
} from '@angular/common/http';

@Injectable()
export class ErrorHandlerHttpClientInterceptor implements HttpInterceptor {
    constructor(private eventManager: JhiEventManager) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): any {
        return next.handle(req).pipe(
            tap((resp) => {
                if (
                    resp instanceof HttpResponse &&
                    resp.body &&
                    resp.body.errors
                ) {
                    throw resp;
                }
            }),
            catchError((error) => {
                // lets not report the error in the ui if it occurs because the user is not logged in,
                // because it would be annoying to show a red banner when simply landing on the app
                const authExpired =
                    error &&
                    error.status === 401 &&
                    error.url.endsWith('/api/account');
                // lets not report the error in the ui if it occurs because the url includes a translated part and
                // the translation has not been loaded yet (it will)
                const translationProblem =
                    error &&
                    error.status === 404 &&
                    error.url.includes('translation-not-found');
                if (!authExpired && !translationProblem) {
                    this.eventManager.broadcast({
                        name: 'platonApp.httpError',
                        content: error,
                    });
                }
                return of(error);
            })
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/blocks/interceptor/errorhandler.interceptor.ts